export interface UpdateUserFelicaIdRequest {
  id: string
  felicaId: string
}

export function UpdateUserFelicaIdRequestToJSON(
  value: UpdateUserFelicaIdRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    felica_id: value.felicaId !== '' ? value.felicaId : undefined
  }
}
